module.exports = __webpack_public_path__ + "media/fonts/IntroRegular-1568c96f.woff2";